export default __webpack_public_path__ + "static/media/info.02ee54fa.svg";